export default __webpack_public_path__ + "static/media/checkbox.c5646342.svg";